var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"mt-n6 pt-0",attrs:{"id":"settings","fluid":"","tag":"section"}},[_c('customerManagement'),_c('div',{staticStyle:{"width":"100%","height":"25px"}}),_c('identityManagement')],1)}
var staticRenderFns = []

export { render, staticRenderFns }